module.exports = "<div class=\"loader\" ng-if=\"loader.isOpened()\">\n\t<img ng-src=\"{{loader.image}}\" class=\"loader__image\" />\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/directive/loader/loader.html
// module id = 509
// module chunks = 0